import { render, staticRenderFns } from "./PortfoliosPage.vue?vue&type=template&id=141196f3&scoped=true"
import script from "./PortfoliosPage.vue?vue&type=script&lang=ts"
export * from "./PortfoliosPage.vue?vue&type=script&lang=ts"
import style0 from "./PortfoliosPage.vue?vue&type=style&index=0&id=141196f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141196f3",
  null
  
)

export default component.exports